import { RESPONSE_STATUS, CLEAR_RESPONSE, SUBSCRIBE_PROFILE_TO_LIST } from './klaviyoTypes'
export default (state, action) => {
    switch (action.type) {
        case SUBSCRIBE_PROFILE_TO_LIST:
            return {
                ...state,
                northCapitalUser: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
